function uniformHeight() {
    // Seleziona tutte le sezioni principali
    const sections = document.querySelectorAll('.textTwoColsCompareMobileAccordionBlock');
    if (sections.length === 0) return;

    sections.forEach((section) => {
        // Seleziona tutti gli elementi .el all'interno della sezione
        const elements = section.querySelectorAll('.el');
        if (elements.length === 0) return;

        // Calcola la lunghezza massima dell'elenco per creare le coppie
        const halfLength = Math.floor(elements.length / 2);

        // Itera sugli indici fino alla metà degli elementi
        for (let i = 0; i < halfLength; i++) {
            const el1 = elements[i];
            const el2 = elements[i + halfLength];
            
            // Ottieni gli elementi border
            const borderEl1 = el1.querySelector('.border-b');
            const borderEl2 = el2.querySelector('.border-b');
            
            // Applica margini in base alla larghezza della finestra
            applyResponsiveMargins(borderEl1, borderEl2);
            
            if (el1 && el2 && window.innerWidth > 768) {
                // Confronta le altezze
                const height1 = el1.offsetHeight;
                const height2 = el2.offsetHeight;
                const maxHeight = Math.max(height1, height2) + 20;

                // Applica l'altezza massima a entrambi gli elementi
                el1.style.height = `${maxHeight}px`;
                el2.style.height = `${maxHeight}px`;
            } else if (el1 && el2) {
                // Resetta le altezze per mobile
                el1.style.height = 'auto';
                el2.style.height = 'auto';
            }
        }
    });
}

// Funzione separata per applicare i margini responsive
function applyResponsiveMargins(borderEl1, borderEl2) {
    const windowWidth = window.innerWidth;
    
    if (borderEl1) {
        // Logica migliorata per i breakpoint
        if (windowWidth > 1279) {
            borderEl1.style.marginRight = '55px';
        } else if (windowWidth > 1024) {
            borderEl1.style.marginRight = '32px';
        } else if (windowWidth > 768) {
            borderEl1.style.marginRight = '-8px';
        } else {
            borderEl1.style.marginRight = '0'; // Resetta per mobile
        }
    }
    
    if (borderEl2) {
        if (windowWidth > 1024) {
            borderEl2.style.marginLeft = '-74px';
        } else if (windowWidth > 768) {
            borderEl2.style.marginLeft = '-48px';
        } else {
            borderEl2.style.marginLeft = '0'; // Resetta per mobile
        }
    }
}

// Chiamata iniziale
window.addEventListener('load', uniformHeight);

// Aggiungi un listener per il ridimensionamento con debounce
let resizeTimer;
window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(uniformHeight, 250); // Esegue dopo 250ms dall'ultimo evento resize
});